import { breakpoints, scrollbar, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const PageContainer = styled.div `
  display: flex;
  flex-direction: column;
  overflow: hidden;
  max-height: 100%;
  height: 100%;
`;
export const PageContent = styled.div `
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;
export const DocumentContainer = styled.div `
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
export const DocumentPageContainer = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  overflow: auto;
  margin: 0;
  height: 100%;
  width: 100%;

  ${breakpoints.sm} {
    padding: ${theme.spacing.md};

    ${scrollbar({ trackMargin: 'xl' })};
  }

  ${breakpoints.lg} {
    padding: ${theme.spacing.lg} ${theme.spacing.md};
  }
`;
